var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongTrainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 10,
    viewBox: "0 0 39 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 4,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 4,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    width: 4,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 4,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    width: 4,
    height: 10,
    rx: 1,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongTrainIcon);
export default __webpack_public_path__ + "static/media/long_train_icon.71fff5fbc3a42803b9cef45098a166a0.svg";
export { ForwardRef as ReactComponent };